// constants/planLimits.js - Prompt-Based Pricing Structure

export const PLAN_LIMITS = {
  free: {
    name: 'Free',
    price: 0,
    productId: null, // Free plan has no product ID
    monthlyProjects: {
      prompt: 5
    },
    features: [
      '5 Prompt-Based Projects per Month',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports'
    ],
    popular: false
  },

  starter: {
    name: 'Starter',
    price: 7,
    productId: 'pdt_0NXbbMdrJyd2bJ3MJPtLN',
    monthlyProjects: {
      prompt: 70
    },
    features: [
      '70 Prompt-Based Projects per Month',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports'
    ],
    popular: false
  },

  creator: {
    name: 'Creator',
    price: 15,
    productId: 'pdt_0NXbbUv7zf6O8xt6pOcbw', // ✅ Dodo product ID
    monthlyProjects: {
      prompt: 200
    },
    features: [
      '200 Prompt-Based Projects per Month',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports',
      'Priority Rendering Queue'
    ],
    popular: true
  },

  professional: {
    name: 'Professional',
    price: 29,
    productId: 'pdt_0NXbbaSvaRyhUyW8u1BFT', // ✅ Dodo product ID
    monthlyProjects: {
      prompt: 350
    },
    features: [
      '350 Prompt-Based Projects per Month',
      'Premium Images in All Templates',
      'Unlimited PNG & PPTX Exports',
      'Priority Support',
      'Priority Rendering Queue'
    ],
    popular: false
  }
};

// ============================================
// UTILITY FUNCTIONS
// ============================================

export const getPlanLimits = (planType) => {
  const normalizedPlan = planType?.toLowerCase() || 'free';
  return PLAN_LIMITS[normalizedPlan] || PLAN_LIMITS.free;
};

export const getAllPlanTypes = () => {
  return Object.keys(PLAN_LIMITS);
};

// Get product ID for a specific plan (useful for checkout)
export const getProductId = (planType) => {
  const plan = getPlanLimits(planType);
  return plan.productId;
};

// Check if a plan has a valid product ID
export const isPlanPurchasable = (planType) => {
  const plan = getPlanLimits(planType);
  return Boolean(plan.productId);
};

export default PLAN_LIMITS;